const UiCheckboxPropsOption = {
  modelValue: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  value: { required: true },
  mode: { type: String, default: "default" },
  size: { type: String, default: "default" }
};
const UiCheckboxEmits = {
  "change": (_ev) => true,
  "update:modelValue": (_data) => true
};

export { UiCheckboxEmits, UiCheckboxPropsOption };
//# sourceMappingURL=index.mjs.map
